import gettext from '@sdk/lang/gettext';
import { BreakViolation } from '@sdk/automatedBreaks/types/BreakViolation';
import { AutomatedBreakType } from '@sdk/settings/types';

const getEndedToSoonMessage = (type: AutomatedBreakType) => {
  if (type === AutomatedBreakType.meal) {
    return gettext('Meal break ended too soon');
  }

  return gettext('Rest break ended too soon');
};

const breakViolationToText = {
  [BreakViolation.endedTooSoon]: getEndedToSoonMessage,
};

export default breakViolationToText;
